import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
};

export default function ApprovedResidentsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_INIT_ACTION:
      return {
        ...state,
        totalOnboardingResList: [],
        loading: true,
      };
    case actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_SUCCESS_ACTION:
      return {
        ...state,
        totalOnboardingResList: action.payload.response_data.apts,
        loading: false,
      };
    case actionTypes.FETCH_TOTALONBOARDINGRESIDENTS_FAIL_ACTION:
      return {
        ...state,
        totalOnboardingResList: [],
        loading: false,
      };
    case actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_INIT_ACTION:
      return {
        ...state,
        recievedOnboardingResList: [],
        recievedloading: true,
      };
    case actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_SUCCESS_ACTION:
      return {
        ...state,
        recievedOnboardingResList: action.payload.response_data.apts,
        recievedloading: false,
      };
    case actionTypes.FETCH_RECIEVEDONBOARDINGRESIDENTS_FAIL_ACTION:
      return {
        ...state,
        recievedOnboardingResList: [],
        recievedloading: false,
      };
    case actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_INIT_ACTION:
      return {
        ...state,
        pendingOnboardingResList: [],
        pendingloading: true,
      };
    case actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_SUCCESS_ACTION:
      return {
        ...state,
        pendingOnboardingResList: action.payload.response_data.apts,
        pendingloading: false,
      };
    case actionTypes.FETCH_PENDINGONBOARDINGRESIDENTS_FAIL_ACTION:
      return {
        ...state,
        pendingOnboardingResList: [],
        pendingloading: false,
      };
    default:
      return {
        ...state,
      };
  }
}
